import styled from 'styled-components'
import { Colors } from '../../theme'
import { Text } from '../Text'
import { StyledDropdownMenuItemProps } from './types'

export const DropdownMenuItem = styled.button<StyledDropdownMenuItemProps & { $isActive: boolean }>`
  align-items: center;
  border-radius: 5px;
  background-color: ${({ $isActive }) => ($isActive ? 'rgba(255, 255, 255, 0.05)' : '0')};
  color: white;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  font-weight: 400;
  display: flex;
  font-size: 14px;
  line-height: 21px;
  height: 40px;
  outline: 0;
  padding-left: 12px;
  padding-right: 16px;
  width: 100%;

  &:hover {
    transition: background-color 0.1s ease-out;
    background-color: rgba(255, 255, 255, 0.05);
  }

  &:active:not(:disabled) {
    opacity: 0.85;
    transform: translateY(1px);
  }
`

export const StyledDropdownMenuItemContainer = styled.div``

export const DropdownMenuDivider = styled.hr`
  border-color: ${({ theme }) => theme.colors.cardBorder};
  border-style: solid;
  border-width: 1px 0 0;
  margin: 4px 0;
`

export const StyledDropdownMenu = styled.div<{ isOpen: boolean; isBottomNav: boolean; isBlackThemePage: boolean }>`
  background: ${({ isBlackThemePage }) => (isBlackThemePage ? '#161616' : '#00334a')};
  box-shadow: 0px ${({ isBottomNav }) => (isBottomNav ? '5px' : '-5px')} 15px rgba(0, 0, 0, 0.15);
  border-radius: 5px;
  width: 210px;
  padding: 10px;
  pointer-events: auto;
  visibility: visible;
  z-index: 1001;

  ${({ isOpen }) =>
    !isOpen &&
    `
    pointer-events: none;
    visibility: hidden;
  `}
`

export const LinkStatus = styled(Text)<{ color: keyof Colors }>`
  border-radius: ${({ theme }) => theme.radii.default};
  padding: 0 8px;
  border: 2px solid;
  border-color: ${({ theme, color }) => theme.colors[color]};
  box-shadow: none;
  color: ${({ theme, color }) => theme.colors[color]};
  margin-left: 8px;
`
